export const normalizeItems = (items) => {
    const byId = {};
    const allIds = [];
    items.forEach(item => {
        if (item.id) {
            byId[item.id] = item;
            allIds.push(item.id);
        }
    });

    return { byId, allIds };
}

export const mergeNormalizedData = (existingById, newById) => {
    return { ...existingById, ...newById };
};

export const updateIds = (existingIds, newIds, replace = false) => {
    if (replace) {
        return newIds;
    }

    const uniqueNewIds = newIds.filter(id => !existingIds.includes(id));
    return [...existingIds, ...uniqueNewIds];
};